export const ChatIcon = ({
  color = "var(--locobuzz-text-color-mention-id)",
  width,
  height,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "16"}
    height={height || "16"}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.66927 2.66683H13.3359V10.6668H3.44927L2.66927 11.4468V2.66683ZM2.66927 1.3335C1.93594 1.3335 1.3426 1.9335 1.3426 2.66683L1.33594 14.6668L4.0026 12.0002H13.3359C14.0693 12.0002 14.6693 11.4002 14.6693 10.6668V2.66683C14.6693 1.9335 14.0693 1.3335 13.3359 1.3335H2.66927ZM4.0026 8.00016H9.33594V9.3335H4.0026V8.00016ZM4.0026 6.00016H12.0026V7.3335H4.0026V6.00016ZM4.0026 4.00016H12.0026V5.3335H4.0026V4.00016Z"
      fill={color}
    />
  </svg>
);
